import React from "react"
import PropTypes from "prop-types"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import TextField from "material-ui/TextField"
import AppStateStore from "../../stores/AppStateStore"

const moment = require("moment")
let saveTimeout

const propTypes = {
    handleChange: PropTypes.func,
    style: PropTypes.object.isRequired
}

export default class DateField extends React.Component {
    constructor(props) {
        super()
        this.state = {
            day: 1,
            month: 1,
            year: "",
            maxDays: 30
        }

        this.handleDateChange = this.handleDateChange.bind(this)
        this.handleMonthChange = this.handleMonthChange.bind(this)
        this.handleDayChange = this.handleDayChange.bind(this)
        this.handleYearChange = this.handleYearChange.bind(this)
        this.onYearFocus = this.onYearFocus.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setupStateFromDate(nextProps.value)
        }
    }

    setupStateFromDate(value, triggerChange) {
        const date = moment(value)

        //valid date
        if (date.year() > 1) {
            const _this = this
            this.setState(
                {
                    date: date.format("YYYY-MM-DD"),
                    year: date.year().toString(),
                    month: date.month(),
                    day: date.date()
                },
                () => {
                    _this.setState({
                        maxDays: moment(new Date(this.state.year, this.state.month)).daysInMonth()
                    })
                    if (triggerChange) {
                        this.triggerChange()
                    }
                }
            )
        }
    }

    handleDayChange(event, index, value) {
        const _this = this
        this.setState({ day: value }, () => {
            this.triggerChange()
        })
    }

    handleMonthChange(event, index, value) {
        const _this = this
        this.setState(
            {
                month: value,
                maxDays: moment(new Date(this.state.year, value)).daysInMonth()
            },
            () => {
                this.triggerChange()
            }
        )
    }

    handleYearChange(event) {
        const _this = this
        this.setState(
            {
                year: event.target.value,
                maxDays: moment(new Date(event.target.value, this.state.month)).daysInMonth()
            },
            () => {
                this.triggerChange()
            }
        )
    }

    onYearFocus() {
        this.refs.yearField.input.select()
    }

    validYear() {
        //make sure the year makes sense.
        if (this.state.year.length < 4) {
            return false
        }

        return true
    }

    getDate() {
        return this.state.year.length === 4 ? moment(new Date(this.state.year, this.state.month, this.state.day)) : null
    }

    triggerChange() {
        if (saveTimeout) {
            clearTimeout(saveTimeout)
        }
        saveTimeout = setTimeout(() => {
            if (this.props.handleChange) {
                this.props.handleChange(this.getDate(), this.validYear())
            }
        }, 750)
    }

    handleDateChange(event) {
        this.setupStateFromDate(event.target.value, true)
    }

    render() {
        if (AppStateStore.isMobile()) {
            return (
                <div className="DateField">
                    <TextField type="date" style={{ width: "60%" }} value={this.state.date} onChange={this.handleDateChange} ref="dateField" />
                    <span style={{ fontSize: 14, marginLeft: 10 }}>{this.state.age}</span>
                </div>
            )
        } else {
            return (
                <div className="DateField" style={this.props.style}>
                    <SelectField value={this.state.month} onChange={this.handleMonthChange} style={{ width: 75, marginRight: 10 }}>
                        <MenuItem value={0} primaryText="JAN" />
                        <MenuItem value={1} primaryText="FEB" />
                        <MenuItem value={2} primaryText="MAR" />
                        <MenuItem value={3} primaryText="APR" />
                        <MenuItem value={4} primaryText="MAY" />
                        <MenuItem value={5} primaryText="JUN" />
                        <MenuItem value={6} primaryText="JUL" />
                        <MenuItem value={7} primaryText="AUG" />
                        <MenuItem value={8} primaryText="SEP" />
                        <MenuItem value={9} primaryText="OCT" />
                        <MenuItem value={10} primaryText="NOV" />
                        <MenuItem value={11} primaryText="DEC" />
                    </SelectField>
                    <SelectField value={this.state.day} onChange={this.handleDayChange} style={{ width: 50, marginRight: 10 }}>
                        {(() => {
                            const menuItems = []
                            for (let i = 0; i <= this.state.maxDays; i++) {
                                menuItems.push(<MenuItem value={i} key={i} primaryText={i} />)
                            }

                            return menuItems
                        })()}
                    </SelectField>
                    <TextField floatingLabelText="Year" style={{ width: 75, top: -4 }} value={this.state.year} onChange={this.handleYearChange} ref="yearField" onFocus={this.onYearFocus} />
                </div>
            )
        }
    }
}

DateField.propTypes = propTypes
